import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { PostContext } from '../contexts/PostContext'; // Import PostContext
import { useDBPosts  } from '../contexts/DBPostsContext'; // Import PostContext

import { Grid, Snackbar, TextField, Button, IconButton, Box,Alert, Typography, List, ListItem, InputAdornment, Select, MenuItem, InputLabel } from '@mui/material';
import { AddCircle, PhotoCamera } from '@mui/icons-material';
import { EditorState, convertToRaw } from 'draft-js';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import Editor from "../components/Editor"; // Assuming this is your rich-text editor component
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const CreatePost = () => {
  // Use context to get the current post data and updatePostData function
  const { postData, updatePostData } = useContext(PostContext);
  const [uploading, setUploading] = useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const { addPost} = useDBPosts();
  // Handle input changes and update the context data
  const handleInputChange = (field, value) => {
    updatePostData({ [field]: value });
  };



  // Handle preview button
  const handlePreview = () => {
    navigate('/blog/preview-post');
  };

  // Add new ingredient
  const addIngredient = () => {
    updatePostData({
      ingredients: [...postData.ingredients, { name: '', amount: '', unit: '' }],
    });
  };

  // Update ingredient details
  const updateIngredient = (index, field, value) => {
    const updatedIngredients = [...postData.ingredients];
    updatedIngredients[index][field] = value;
    updatePostData({ ingredients: updatedIngredients });
  };

  // Add new instruction
  const addInstruction = () => {
    updatePostData({
      instructions: [...postData.instructions, ''],
    });
  };

  // Update instruction
  const updateInstruction = (index, value) => {
    const updatedInstructions = [...postData.instructions];
    updatedInstructions[index] = value;
    updatePostData({ instructions: updatedInstructions });
  };

  // Add new note
  const addNote = () => {
    updatePostData({
      notes: [...postData.notes, ''],
    });
  };

  // Update note
  const updateNote = (index, value) => {
    const updatedNotes = [...postData.notes];
    updatedNotes[index] = value;
    updatePostData({ notes: updatedNotes });
  };

  // Handle additional info change
  const handleAdditionalInfoChange = (field, value) => {
    updatePostData({
      additionalInfo: { ...postData.additionalInfo, [field]: value },
    });
  };

 // Function to handle post submission
 const handlePublish = async (ev) => {
  ev.preventDefault();

  // Prepare form data for submission
  const data = new FormData();
  data.set('visability', postData.visability);
  data.set('category', postData.category);
  data.set('postType', postData.postType);
  data.set('title', postData.title);
  data.set('summary', postData.summary);
  data.set('content', postData.content);
  data.set('file', postData.file);
  data.set('ingredients', JSON.stringify(postData.ingredients)); // Convert array to JSON string
  data.set('instructions', JSON.stringify(postData.instructions)); // Convert array to JSON string
  data.set('notes', JSON.stringify(postData.notes)); // Convert array to JSON string
  data.set('additionalInfo', JSON.stringify(postData.additionalInfo)); // Convert object to JSON string

  try {
    setUploading(true)
    // Add the post using the DBPostsContext function
    await addPost(data);
    
    // Show success message and redirect after a short delay
    setOpenSnackbar(true);
    setTimeout(() => {
      navigate(`/blog/`); // Redirect to the new post page
    }, 2000);
  } catch (error) {
    console.error('Error publishing post:', error);
  } finally {
    setUploading(false)
  }
  
};

    // Handle closing the snackbar
    const handleCloseSnackbar = () => {
      setOpenSnackbar(false);
    };

    const postCategories = (postType) => {
      if (postType === 'recipe') {
        return ['Dinner', 'Lunch', 'Breakfast', 'Brunch', 'Snacks', 'Afternoon Tea', 'Dessert', 'Appetizer'];
      } else {
        return [ 'Culinary Tips', 'Restaurant Management', 'Travel & Food'];
      }
    }

  return (
    <Box sx={{ padding: '3% 10%' }}>
      <form onSubmit={handlePublish} >
        <Typography variant="h4" gutterBottom>Create a New Post</Typography>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Recipe Title"
              value={postData.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              variant="outlined"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Sub-heading"
              value={postData.summary}
              onChange={(e) => handleInputChange('summary', e.target.value)}
              variant="outlined"
              required
            />
          </Grid>
        </Grid>

        {/* Image Upload */}
        <Box>
  <InputLabel>Upload Post Image</InputLabel>
  <IconButton component="label" sx={{color: '#ca7735'}}>
    <PhotoCamera className='po' />
    <input 
      type="file" 
      accept="image/*" // Restrict to images
      hidden       
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          handleInputChange('file', file);  // Use 'file' for a single file
        }
      }}
    />
  </IconButton>

  {postData.file && (
    <img 
      src={URL.createObjectURL(postData.file)} 
      alt="Uploaded" 
      style={{ width: '100%', marginTop: '1rem' }} 
    />
  )}
</Box>



        {/* Post Content */}
        <Box sx={{ marginTop: '3%', marginBottom: '5%' }}>
          <Editor
            value={postData.content}
            onChange={(newContent) => handleInputChange('content', newContent)}
          />
        </Box>

        <Box sx={{ my: '1rem', display: 'flex', justifyContent: 'start',}} gap={5}>
       
        <FormControl>
        <FormLabel>Post Visability</FormLabel>
        <RadioGroup
  value={postData.visability}
  onChange={(e) => handleInputChange('visability', e.target.value)}
  row
>
  <FormControlLabel
    value="public"
    control={
      <Radio
        sx={{
          color: '#ca7735',
          '&.Mui-checked': {
            color: '#ca7735',
          },
        }}
      />
    }
    label="Public"
  />
  <FormControlLabel
    value="members"
    control={
      <Radio
        sx={{
          color: '#ca7735',
          '&.Mui-checked': {
            color: '#ca7735',
          },
        }}
      />
    }
    label="Member-exclusive"
  />
</RadioGroup>

        </FormControl>

        {/* Post Type */}
        <FormControl>
          <FormLabel>Post Type</FormLabel>
          <RadioGroup
            value={postData.postType}
            onChange={(e) => handleInputChange('postType', e.target.value)}
            row
          >
            <FormControlLabel 
            
            value="article" 
            control={ <Radio
              sx={{
                color: '#ca7735',
                '&.Mui-checked': {
                  color: '#ca7735',
                },
              }}
            />}
             label="Article" />
            <FormControlLabel 
            
            value="recipe" 
            control={ <Radio
              sx={{
                color: '#ca7735',
                '&.Mui-checked': {
                  color: '#ca7735',
                },
              }}
            />} 
            label="Recipe" />
          </RadioGroup>
        </FormControl>
        </Box>

        {postData.postType === 'article' && (

        <Box sx={{ my: '1rem', display: 'flex', justifyContent: 'start',}} gap={5}>
        <FormControl fullWidth>
          <FormLabel>Select category</FormLabel>
          <TextField
              select
              fullWidth
              variant="outlined"
               
              value={postData.category}
              onChange={(e) => handleInputChange('category', e.target.value)}
              required
            >
             {postCategories(postData.postType).map((category, index) => (
              <MenuItem fullWidth key={index} value={category}>
              {category}
              </MenuItem>
             ))}
            </TextField>
        </FormControl>
        </Box>
        )}

        {postData.postType === 'recipe' && (
          <>
            {/* Ingredients Section */}
            <Typography variant="h5" gutterBottom>Key Ingredients</Typography>
            {postData.ingredients.map((ingredient, index) => (
              <Grid container spacing={2} key={index} mb={2}>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Ingredient Name"
                    value={ingredient.name}
                    onChange={(e) => updateIngredient(index, 'name', e.target.value)}
                    variant="outlined"
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Amount (optional)"
                    value={ingredient.amount}
                    onChange={(e) => updateIngredient(index, 'amount', e.target.value)}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={4}>
                  <Select
                    fullWidth
                    value={ingredient.unit}
                    onChange={(e) => updateIngredient(index, 'unit', e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value=""><em>Select Unit</em></MenuItem>
                    <MenuItem value="grams">Grams</MenuItem>
                    <MenuItem value="kg">Kg</MenuItem>
                    <MenuItem value="pieces">Pieces</MenuItem>
                    <MenuItem value="tablespoon">Tablespoon</MenuItem>
                    <MenuItem value="teaspoon">Teaspoon</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            ))}
            <Button   className='unit-btn active' onClick={addIngredient} sx={{ marginBottom: '2rem' }}>Add Ingredient</Button>

            {/* Instructions Section */}
            <Typography variant="h5" gutterBottom>Instructions</Typography>
            <List>
              {postData.instructions.map((instruction, index) => (
                <ListItem key={index}>
                  <TextField
                    fullWidth
                    label={`Step ${index + 1}`}
                    value={instruction}
                    onChange={(e) => updateInstruction(index, e.target.value)}
                    variant="outlined"
                  />
                </ListItem>
              ))}
            </List>
            <Button      className='unit-btn' onClick={addInstruction} sx={{ marginBottom: '2rem' }}>Add Instruction</Button>

            {/* Notes Section */}
            <Typography variant="h5" gutterBottom>Notes</Typography>
            <List>
              {postData.notes.map((note, index) => (
                <ListItem key={index}>
                  <TextField
                    fullWidth
                    label={`Note ${index + 1}`}
                    value={note}
                    onChange={(e) => updateNote(index, e.target.value)}
                    variant="outlined"
                  />
                </ListItem>
              ))}
            </List>
            <Button   className='unit-btn active' onClick={addNote} sx={{ marginBottom: '2rem' }}>Add Note</Button>

            {/* Additional Info Section */}
            <Typography variant="h5" gutterBottom>Additional Info</Typography>
            <Grid container spacing={2} display="flex" justifyContent="center" alignItems="center"> 
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="Prep Time"
                  value={postData.additionalInfo.prepTime}
                  onChange={(e) => handleAdditionalInfoChange('prepTime', e.target.value)}
                  variant="outlined"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Minutes</InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="Cook Time"
                  value={postData.additionalInfo.cookTime}
                  onChange={(e) => handleAdditionalInfoChange('cookTime', e.target.value)}
                  variant="outlined"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Minutes</InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="Servings"
                  value={postData.additionalInfo.serving}
                  onChange={(e) => handleAdditionalInfoChange('serving', e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={3}>           
   
                <FormControl fullWidth>
               
                  <TextField
                      select
                      fullWidth
                      variant="outlined"
                      label="Select category"
                      value={postData.category}
                      onChange={(e) => handleInputChange('category', e.target.value)}
                      required
                    >
                    {postCategories(postData.postType).map((category, index) => (
                      <MenuItem fullWidth key={index} value={category}>
                      {category}
                      </MenuItem>
                    ))}
                    </TextField>
                </FormControl>
         
                

              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Cook Method"
                  value={postData.additionalInfo.method}
                  onChange={(e) => handleAdditionalInfoChange('method', e.target.value)}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Cuisine"
                  value={postData.additionalInfo.cuisine}
                  onChange={(e) => handleAdditionalInfoChange('cuisine', e.target.value)}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </>
        )}

      

           {/* Buttons: Back to Editor & Publish Recipe */}
           <Box display="flex" justifyContent="space-between" mt={4} gap={2}>
            <button
            style={{
         
            }}
              variant="outlined"
              color="secondary"
              onClick={handlePreview}
              className='unit-btn'
            >
              Preview Recipe
            </button>

            <button
               style={{
             
              }}
              disabled={uploading}
              type="submit"
              variant="contained"
              color="primary"
              onClick={handlePublish}
              className='unit-btn active'
            >
              Publish Recipe
            </button>
          </Box>
      </form>
         {/* Snackbar for success message */}
         <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          Recipe published successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreatePost;
